// extracted by mini-css-extract-plugin
export default {"backDrop":"ModalWrapper_backDrop__VnJuC","modalWrapper":"ModalWrapper_modalWrapper__KcT8E"};